export const CDASH_MODEL = [
  {
    title: "variable Order",
    dataIndex: "variableOrder",
  },
  {
    title: "CDASH Variable",
    dataIndex: "variable", // 对应接口返回的 "variable"
  },
  {
    title: "CDASH Variable Label",
    dataIndex: "variableLabel", // 对应接口返回的 "variableLabel"
  },
  {
    title: "DRAFT CDASH Definition",
    dataIndex: "draftDefinition", // 对应接口返回的 "draftDefinition"
  },
  {
    title: "Domain Specific",
    dataIndex: "domainSpecific", // 对应接口返回的 "domainSpecific"
  },
  {
    title: "Question Text",
    dataIndex: "questionText", // 对应接口返回的 "questionText"
  },
  {
    title: "Prompt",
    dataIndex: "prompt", // 对应接口返回的 "prompt"
  },
  {
    title: "Type",
    dataIndex: "type", // 对应接口返回的 "type"
  },
  {
    title: "SDTM Target",
    dataIndex: "target", // 对应接口返回的 "target"
  },
  {
    title: "Mapping Instructions",
    dataIndex: "mappingInstructions", // 对应接口返回的 "mappingInstructions"
  },
  {
    title: "Controlled Terminology Codelist Code",
    dataIndex: "codelistCode", // 对应接口返回的 "codelistCode"
  },
  {
    title: "Implementation Notes",
    dataIndex: "implementationNotes", // 对应接口返回的 "implementationNotes"
  },
];
export const CDASH_MODEL_CN = [
  {
    title: "变量序号",
    dataIndex: "variableOrder",
  },
  {
    title: "CDASH变量",
    dataIndex: "variable", // 对应接口返回的 "variable"
  },
  {
    title: "CDASH变量名称",
    dataIndex: "variableLabel", // 对应接口返回的 "variableLabel"
  },
  {
    title: "CDASH定义",
    dataIndex: "draftDefinition", // 对应接口返回的 "draftDefinition"
  },
  {
    title: "表单特定",
    dataIndex: "domainSpecific", // 对应接口返回的 "domainSpecific"
  },
  {
    title: "问题文本",
    dataIndex: "questionText", // 对应接口返回的 "questionText"
  },
  {
    title: "提示语",
    dataIndex: "prompt", // 对应接口返回的 "prompt"
  },
  {
    title: "类型",
    dataIndex: "type", // 对应接口返回的 "type"
  },
  {
    title: "SDTM目标",
    dataIndex: "target", // 对应接口返回的 "target"
  },
  {
    title: "映射说明",
    dataIndex: "mappingInstructions", // 对应接口返回的 "mappingInstructions"
  },
  {
    title: "受控术语Codelist Code",
    dataIndex: "codelistCode", // 对应接口返回的 "codelistCode"
  },
  {
    title: "实施说明",
    dataIndex: "implementationNotes", // 对应接口返回的 "implementationNotes"
  },
];
export const CDASHIG = [
  {
    title:"Data Collection Scenario/Implementation Option",
    dataIndex:"dcso"
  },
  {
    title: "variable Order",
    dataIndex: "variableOrder",
  },
  {
    title: "CDASHIG Variable",
    dataIndex: "variable", // 对应接口返回的 "variable"
  },
  {
    title: "CDASHIG Variable Label",
    dataIndex: "variableLabel", // 对应接口返回的 "variableLabel"
  },
  {
    title: "DRAFT CDASHIG Definition",
    dataIndex: "draftDefinition", // 对应接口返回的 "draftDefinition"
  },
  {
    title: "Question Text",
    dataIndex: "questionText",
  },
  {
    title: "Prompt",
    dataIndex: "prompt",
  },
  {
    title: "Type",
    dataIndex: "type",
  },
  {
    title: "CDASHIG Core",
    dataIndex: "cdashigCore",
  },
  {
    title: "Case Report Form Completion Instructions",
    dataIndex: "caseReportFormCompletionInstructions",
  },
  {
    title: "SDTMIG Target",
    dataIndex: "target",
  },
  {
    title: "Mapping Instructions",
    dataIndex: "mappingInstructions",
  },
  {
    title: "CDISC CT Codelist Code(s), Subset Codes(s)",
    dataIndex: "codelistCode",
  },
  {
    title: "Implementation Notes",
    dataIndex: "implementationNotes",
  },
];
export const CDASHIG_CN = [
  {
    title: "数据采集场景/实施选项",
    dataIndex: "dcso",
  },
  {
    title: "变量序号",
    dataIndex: "variableOrder",
  },
  {
    title: "CDASH变量",
    dataIndex: "variable", // 对应接口返回的 "variable"
  },
  {
    title: "CDASH变量名称",
    dataIndex: "variableLabel", // 对应接口返回的 "variableLabel"
  },
  {
    title: "CDASHIG定义",
    dataIndex: "draftDefinition", // 对应接口返回的 "draftDefinition"
  },
  {
    title: "问题文本",
    dataIndex: "questionText",
  },
  {
    title: "提示语",
    dataIndex: "prompt",
  },
  {
    title: "类型",
    dataIndex: "type",
  },
  {
    title: "CDASH核心",
    dataIndex: "cdashigCore",
  },
  {
    title: "病例报告表填写说明",
    dataIndex: "caseReportFormCompletionInstructions",
  },
  {
    title: "SDTMIG目标",
    dataIndex: "target",
  },
  {
    title: "映射说明",
    dataIndex: "mappingInstructions",
  },
  {
    title: "CDISC受控术语Codelist Code(s), Subset Codes(s)",
    dataIndex: "codelistCode",
  },
  {
    title: "实施说明",
    dataIndex: "implementationNotes",
  },
];
export const SDTM = [
  {
    title: "variable Order",
    dataIndex: "variableOrder",
  },
  {
    title: "Variable Name",
    dataIndex: "variableName", // 对应接口返回的 "variableName"
  },
  {
    title: "Variable Label",
    dataIndex: "variableLabel", // 对应接口返回的 "variableLabel"
  },
  {
    title: "Type",
    dataIndex: "type", // 对应接口返回的 "type"
  },
  {
    title: "Described Value Domain",
    dataIndex: "describedValueDomain", // 对应接口返回的 "describedValueDomain"
  },
  {
    title: "Role",
    dataIndex: "role", // 对应接口返回的 "role"
  },
  {
    title: "Variables Qualified",
    dataIndex: "variablesQualified", // 对应接口返回的 "variablesQualified"
  },
  {
    title: "Usage Restrictions",
    dataIndex: "usageRestrictions", // 对应接口返回的 "usageRestrictions"
  },
  {
    title: "Variable C-Code",
    dataIndex: "variableCCode", // 对应接口返回的 "variableCCode"
  },
  {
    title: "Definition",
    dataIndex: "definition", // 对应接口返回的 "definition"
  },
  {
    title: "Notes",
    dataIndex: "notes", // 对应接口返回的 "notes"
  },
  {
    title: "Examples",
    dataIndex: "examples", // 对应接口返回的 "examples"
  },
];
export const SDTM_CN = [
  {
    title: "变量序号",
    dataIndex: "variableOrder",
  },
  {
    title: "变量",
    dataIndex: "variableName", // 对应接口返回的 "variableName"
  },
  {
    title: "变量名称",
    dataIndex: "variableLabel", // 对应接口返回的 "variableLabel"
  },
  {
    title: "类型",
    dataIndex: "type", // 对应接口返回的 "type"
  },
  {
    title: "描述值域",
    dataIndex: "describedValueDomain", // 对应接口返回的 "describedValueDomain"
  },
  {
    title: "角色",
    dataIndex: "role", // 对应接口返回的 "role"
  },
  {
    title: "合格变量",
    dataIndex: "variablesQualified", // 对应接口返回的 "variablesQualified"
  },
  {
    title: "使用限制",
    dataIndex: "usageRestrictions", // 对应接口返回的 "usageRestrictions"
  },
  {
    title: "变量C-Code",
    dataIndex: "variableCCode", // 对应接口返回的 "variableCCode"
  },
  {
    title: "定义",
    dataIndex: "definition", // 对应接口返回的 "definition"
  },
  {
    title: "说明",
    dataIndex: "notes", // 对应接口返回的 "notes"
  },
  {
    title: "样例",
    dataIndex: "examples", // 对应接口返回的 "examples"
  },
];
export const SDTMIG = [
  {
    title: "variable Order",
    dataIndex: "variableOrder",
  },
  {
    title: "Variable Name",
    dataIndex: "variableName", // 对应接口返回的 "variableName"
  },
  {
    title: "Variable Label",
    dataIndex: "variableLabel", // 对应接口返回的 "variableLabel"
  },
  {
    title: "Type",
    dataIndex: "type", // 对应接口返回的 "type"
  },
  {
    title: "CDISC CT Codelist Code(s)",
    dataIndex: "cdiscCtCodelistCodes", // 对应接口返回的 "cdiscCtCodelistCodes"
  },
  {
    title: "Codelist Submission Values",
    dataIndex: "codelistSubmissionValues", // 对应接口返回的 "codelistSubmissionValues"
  },
  {
    title: "Described Value Domain(s)",
    dataIndex: "describedValueDomain", // 对应接口返回的 "describedValueDomain"
  },
  {
    title: "Value List",
    dataIndex: "valueList", // 对应接口返回的 "valueList"
  },
  {
    title: "Role",
    dataIndex: "role", // 对应接口返回的 "role"
  },
  {
    title: "CDISC Notes",
    dataIndex: "notes", // 对应接口返回的 "notes"
  },
  {
    title: "Core",
    dataIndex: "core", // 对应接口返回的 "core"
  },
];
export const SDTMIG_CN = [
  {
    title: "变量序号",
    dataIndex: "variableOrder",
  },
  {
    title: "变量",
    dataIndex: "variableName", // 对应接口返回的 "variableName"
  },
  {
    title: "变量名称",
    dataIndex: "variableLabel", // 对应接口返回的 "variableLabel"
  },
  {
    title: "类型",
    dataIndex: "type", // 对应接口返回的 "type"
  },
  {
    title: "CDISC受控术语Codelist Code(s)",
    dataIndex: "cdiscCtCodelistCodes", // 对应接口返回的 "cdiscCtCodelistCodes"
  },
  {
    title: "受控术语提交值",
    dataIndex: "codelistSubmissionValues", // 对应接口返回的 "codelistSubmissionValues"
  },
  {
    title: "描述值域",
    dataIndex: "describedValueDomain", // 对应接口返回的 "describedValueDomain"
  },
  {
    title: "值列表",
    dataIndex: "valueList", // 对应接口返回的 "valueList"
  },
  {
    title: "角色",
    dataIndex: "role", // 对应接口返回的 "role"
  },
  {
    title: "CDISC说明",
    dataIndex: "notes", // 对应接口返回的 "notes"
  },
  {
    title: "核心",
    dataIndex: "core", // 对应接口返回的 "core"
  },
];
export const OMOPCDM = [
  {
    title: "CDM Field",
    dataIndex: "cdmField",
    key: "cdmField",
  },
  {
    title: "User Guide",
    dataIndex: "userGuide",
    key: "userGuide",
  },
  {
    title: "ETL Conventions",
    dataIndex: "etlConventions",
    key: "etlConventions",
  },
  {
    title: "Datatype",
    dataIndex: "datatype",
    key: "datatype",
  },
  {
    title: "Required",
    dataIndex: "required",
    key: "required",
  },
  {
    title: "Primary Key",
    dataIndex: "primaryKey",
    key: "primaryKey",
  },
  {
    title: "Foreign Key",
    dataIndex: "foreignKey",
    key: "foreignKey",
  },
  {
    title: "FK Table",
    dataIndex: "fkTable",
    key: "fkTable",
  },
  {
    title: "FK Domain",
    dataIndex: "fkDomain",
    key: "fkDomain",
  },
];
